import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { BaseService } from './base';
import { HttpService } from './http.service';
import { MenuGroup, MenuItem } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MenuService extends BaseService {
  private selectedMenuItem: MenuItem;

  private menuGroups: MenuGroup[];
  private currentMenuItems: MenuItem[] = [];

  constructor(protected httpService: HttpService) {
    super('Menu', httpService);
  }

  get hasMenuItems() {
    return this.currentMenuItems.length > 0;
  }

  get isReadOnly(): boolean {
    return this.selectedMenuItem?.readOnly ?? false;
  }

  get menus(): Observable<MenuGroup[]> {
    if (this.menuGroups) {
      return of(this.menuGroups);
    }

    return this.httpService.get<MenuGroup[]>(this.apiUrl).pipe(tap((menus: MenuGroup[]) => (this.menuGroups = menus)));
  }

  loadMenuGroups(menuGroups: MenuGroup[]) {
    this.menuGroups = menuGroups;
  }

  menuItems(route: string): Observable<MenuItem[]> {
    return this.menus.pipe(
      map((menus: MenuGroup[]) => {
        this.currentMenuItems = menus.find((menuGroup: MenuGroup) => route.indexOf(menuGroup.route) === 0)?.items ?? [];
        return this.currentMenuItems;
      }),
    );
  }

  menuItem(route: string): Observable<MenuItem> {
    return this.menuItems(route).pipe(
      map((menuItems: MenuItem[]) => {
        this.selectedMenuItem = menuItems.find((menuItem: MenuItem) => route.indexOf(menuItem.route) === 0);
        return this.selectedMenuItem;
      }),
    );
  }
}
